module.exports = __webpack_public_path__ + "img/airplane.a797c3bb.svg";